/**
 * BoardStage - Layout wrapper for puzzle board positioning
 */
import { cx } from '@utils/cx'
import styles from './BoardStage.module.css'

export default function BoardStage ({
  children,
  className = '',
  size,
  ...props
}) {
  return (
    <div
      className={cx(styles.puzzleBoardStage, 'puzzle-board-stage', className)}
      style={{ '--puzzle-size': size }}
      {...props}
    >
      {children}
    </div>
  )
}
